module.exports = __webpack_public_path__ + "static/media/mobile-partner.1a9e5dfb.png";